<script setup>
import { storeToRefs } from "pinia";
    import { ref, onBeforeMount, computed, watch } from "vue";
    import { useUiStore } from "@/stores/ui";
    import { useDataMappingStore } from "@/stores/dataMapping";
import { useCompanyStore } from "@/stores/company";

    const uiStore = useUiStore();
    const dataMappingStore = useDataMappingStore();
    const emit = defineEmits(['refresh', 'refreshSitesArr']);
    const getModalInfo = computed(() => uiStore.modalData);
    const getModalAction = computed(() => uiStore.modalAction);
    const { companyId } = storeToRefs(useCompanyStore());

    let fileDataMappingObj = ref({});
    let dataMappingSchemaOptions = ref([]);
    let dataMappingSessionFieldsOptions = ref([]);
    let mappedFields = ref([]);
    let isSubmitted = ref(false);
    let isDisabled = ref(false);

    // Helper to update disabled state for options
    // const updateDisabledOptions = () => {
    //   const selectedIdsDataMapping = mappedFields.value.map(field => field.source_field && field.source_field.id).filter(Boolean);
    //   const selectedIdsMappedKeys = mappedFields.value.map(field => field.target_column && field.target_column.id).filter(Boolean);

    //   dataMappingStaticKeysOptions.value = dataMappingStaticKeysOptions.value.map(option => {
    //     option.isDisabled = selectedIdsDataMapping.includes(option.id) ? true : false;
    //     return option;
    //   });
    //   dataMappingSimilarStaticKeysOptions.value = dataMappingSimilarStaticKeysOptions.value.map(option => {
    //     option.isDisabled = selectedIdsMappedKeys.includes(option.id) ? true : false;
    //     return option;
    //   });
    // };

    watch(mappedFields.value, async (newValue) => {
        isDisabled.value = false;
        if (newValue.length > 0) {
          isDisabled.value = newValue.some(field => !field.source_field || !field.target_column);
          // updateDisabledOptions();
        }
    })

    const resetStoreData = () => {
        uiStore.setModalState(false);
        uiStore.setModalData({});
        uiStore.setModalAction(null);
    };

    const fetchDataMappingSessionFields = () => {
      dataMappingStore.fetchDataMappingSessionFields({companyId : companyId.value, sessionId : fileDataMappingObj.value.id }).then((res) => {
        dataMappingSessionFieldsOptions.value = res.source_fields;
      }).catch(() => {
      })

      // dataMappingSessionFieldsOptions.value = fileDataMappingObj.value.mappings;
    }

    const fetchDataMappingSchemaKeys = () => {
      dataMappingStore.fetchDataMappingSchemaKeys(companyId.value).then((res) => {
        dataMappingSchemaOptions.value = res.schema_fields;
      }).catch(() => {
      })
    }

    // const addMappedField = () => {
    //   mappedFields.value.push({ source_field : null, target_column : null });
    //   // mappedFields.value.map((field) => {
    //   if(!field.source_field || !field.target_column){
    //   //     isDisabled.value = true;
    //   //   }
    //   //   dataMappingStaticKeysOptions.value = dataMappingStaticKeysOptions.value.map(option => {
    //   if (field.source_field && option.id === field.source_field.id) {
    //   //    //   //       option.isDisabled = true;
    //   //    //   //     return option;
    //   //   });
    //   // });
    // };

    // const removeMappedField = (index)  =>  {
    //   if (autoBrightnessFields.value.length > 1) {
    //     mappedFields.value.splice(index, 1)
    //   // }
    // };

    const onSubmit = async () => {

      isSubmitted.value = true;
            let itemsArr = [];
      mappedFields.value.map((field) =>{
        let itemObj = {};
        itemObj.id = field.source_field.id;
        itemObj.source_field = field.source_field.source_field;
        itemObj.target_column = field.target_column;
        itemsArr.push(itemObj);
      });
      
      const data = {
        sessionId: fileDataMappingObj.value.id,
        companyId: companyId.value,
        items: mappedFields.value,
      };
      dataMappingStore.editDataMapping(data).then(() => {
        emit('refresh');
        resetStoreData();
      }).catch(() => {
        isSubmitted.value = false;
      });
    }

    onBeforeMount(async ()=>{
      if(getModalInfo.value && getModalAction.value == 'mapping_data'){
        //        fileDataMappingObj.value = await getModalInfo.value;
        dataMappingSessionFieldsOptions
        fileDataMappingObj.value.mappings.map((field) => {
          mappedFields.value.push({
            id : field.id,
            source_field : field.source_field ,
            target_column : field.target_column,
          });
        });

        fetchDataMappingSchemaKeys();
        fetchDataMappingSessionFields();
      }

    });

</script>

<template>
  <DModal v-if="getModalAction === 'show_data_mapping'" :visible="uiStore.modalState" @update:visible="val => { if (!val) resetStoreData() }" :main_classes="['modal-xl']" :dialog_classes="[]">
    <template #title> Mapping Data </template>
    
    <template #body>
        
        <div v-if="mappedFields && mappedFields.length">
            <div class="flex mb-2" v-for="(field, index) in mappedFields" :key="index">
                <div class="flex items-center justify-between config_settings_time">
                <div class="flex ml-20">
                    <div class="relative mb-3"> 
                        <span v-if="field.source_field" class="multiselect-title-span disabled-div">Source Field</span>
                        <VMultiselect v-model="field.source_field" :options="dataMappingSessionFieldsOptions" :disabled="true"
                        :searchable="true" :close-on-select="true" :show-labels="false" placeholder="Source Field" />
                    </div>
                </div>

                <span class="ml-20 mr-20 mb-15"><i class="bi bi-arrow-right "></i> </span>

                <div class="flex mr-30">
                    <div class="relative mb-3"> 
                        <span v-if="field.target_column" class="multiselect-title-span">Target Column</span>
                        <VMultiselect v-model="field.target_column" :options="dataMappingSchemaOptions"
                        :searchable="true" :close-on-select="true" :show-labels="false" placeholder="Target Column" />
                    </div>
                </div>

                <!-- <span @click="removeMappedField(index)" class="ml-40 cursor-pointer mb-15">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 22 22" fill="none" >
                    <path fill="#F46A6A"
                        d="M11 0C4.91333 0 0 4.91333 0 11C0 17.0867 4.91333 22 11 22C17.0867 22 22 17.0867 22 11C22 4.91333 17.0867 0 11 0ZM16.5978 14.7156C17.1111 15.2289 17.1111 16.06 16.5978 16.5733C16.3289 16.8422 16.0111 16.9644 15.6689 16.9644C15.3267 16.9644 14.9844 16.8422 14.74 16.5733L11.0733 12.9067L7.38222 16.5733C7.11333 16.8422 6.79556 16.9644 6.45333 16.9644C6.11111 16.9644 5.76889 16.8422 5.52444 16.5733C5.01111 16.06 5.01111 15.2289 5.52444 14.7156L9.21556 11.0244L5.52444 7.35778C5.01111 6.84444 5.01111 6.01333 5.52444 5.5C6.03778 4.98667 6.86889 4.98667 7.38222 5.5L11.0733 9.19111L14.7644 5.5C15.2778 4.98667 16.1089 4.98667 16.6222 5.5C17.1356 6.01333 17.1356 6.84444 16.6222 7.35778L12.9311 11.0489L16.5978 14.7156Z"
                    />
                    </svg>
                </span> -->

                </div>
            </div>

            <!-- <button :disabled="isSubmitted"  @click="addMappedField" type="button" class="btn btn-success m-5 font-14 mass-action-grid-btn  float-right">
                Add New
            </button> -->
            </div>

            <div v-else class="flex justify-center">
            <div class="no-times-card mt-40">
                <p class="second-success-card-email-message mt-15 text-center">No mapped fields found</p>
                <div class="text-center">
                    <!-- <button  @click="addMappedField" type="button" class="btn btn-success m-5 font-14 mass-action-grid-btn">
                    Add New
                    </button> -->
                </div>
            </div>
        </div>        

    </template>

    <template #footer>
      <div class="w-full">
        <div class="seperator text-center"></div>
        <div class="flex mt-20 justify-center">
          <button :disabled="!mappedFields || isDisabled || !mappedFields.length || isSubmitted" @click="onSubmit" type="button" class="btn btn-primary add-button mr-30">Update 
            <span v-if="isSubmitted" class="spinner-sm" role="status" aria-hidden="true"></span></button>
          <button @click="resetStoreData" type="button" class="btn btn-secondary cancel-button"> Cancel </button>
        </div>
      </div>
    </template>

  </DModal>
</template>
<style scoped lang="scss">

.files-grid {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: var(--spacing-1);
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }

  .files-card {
    padding: var(--spacing-4);
    border: 1px solid var(--neutral-200);
    border-radius: var(--border-radius-md);
    display: flex;
    gap: var(--spacing-1);
    &:hover {
      border-color: var(--primary-200);
      background-color: var(--primary-50);
      
      .files-icon {
        background-color: var(--primary-500);
        color: white;
      }
    }
  }

  .files-icon {
    width: 40px;
    height: 40px;
    border-radius: var(--border-radius-md);
    background-color: var(--neutral-100);
    color: var(--neutral-600);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: all 0.2s ease;
  }

  .files-content {
    width: 388px;
    h3 {
      margin: 0 0 var(--spacing-1) 0;
      font-size: var(--text-base);
    }
    
    p {
      margin: 0;
      font-size: var(--text-sm);
      color: var(--neutral-600);
    }
  }

  .files-actions{
    margin-left: auto;
    gap: var(--spacing-2);
  }

}
</style>
